import { render } from "./ListeDetachement.vue?vue&type=template&id=2a8574bc&ts=true"
import script from "./ListeDetachement.vue?vue&type=script&lang=ts"
export * from "./ListeDetachement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__